/**
 * PEAK Contact Form — optional secondary routing
 *
 * Shopify's native contact form (the {% form 'contact' %} tag) already
 * emails the store's configured notification address on every submit —
 * that happens automatically, server-side, with no JS involved, and is
 * NOT affected by anything in this file.
 *
 * This script ONLY adds an extra, best-effort copy of the email address
 * (and a few other fields) to a second destination — Mailchimp, Klaviyo,
 * Zapier, or a custom webhook — if the merchant has configured one in
 * the section's Theme Editor settings. It never blocks or interferes
 * with the real submission: the browser is always allowed to navigate
 * away and complete the native Shopify form post normally.
 */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function sendToIntegration(section, form) {
    var service = section.dataset.integrationService;
    var url = section.dataset.integrationUrl;
    var emailField = section.dataset.integrationEmailField || 'email';

    if (!service || service === 'none' || !url) return;

    var emailInput = form.querySelector('[data-peak-contact-email]');
    var nameInput = form.querySelector('[name="contact[name]"]');
    var phoneInput = form.querySelector('[name="contact[phone]"]');
    var subjectInput = form.querySelector('[name="contact[Subject]"]');
    var messageInput = form.querySelector('[name="contact[body]"]');

    var email = emailInput ? emailInput.value : '';
    if (!email) return;

    try {
      if (service === 'mailchimp' || service === 'klaviyo') {
        // Both are typically simple form-encoded POSTs to a public
        // embed/subscribe endpoint.
        var params = new URLSearchParams();
        params.append(emailField, email);
        if (nameInput && nameInput.value) {
          params.append('FNAME', nameInput.value);
        }

        fetch(url, {
          method: 'POST',
          mode: 'no-cors',
          keepalive: true,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: params.toString()
        }).catch(function () {
          /* Best-effort only — the native Shopify submission is unaffected. */
        });
      } else {
        // Zapier / custom webhook: send a plain JSON payload.
        var payload = {};
        payload[emailField] = email;
        payload.name = nameInput ? nameInput.value : '';
        payload.phone = phoneInput ? phoneInput.value : '';
        payload.subject = subjectInput ? subjectInput.value : '';
        payload.message = messageInput ? messageInput.value : '';

        fetch(url, {
          method: 'POST',
          mode: 'no-cors',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).catch(function () {
          /* Best-effort only — the native Shopify submission is unaffected. */
        });
      }
    } catch (e) {
      /* Never let this block the real form submission. */
    }
  }

  function init() {
    document.querySelectorAll('[data-peak-contact-form]').forEach(function (form) {
      var section = form.closest('[data-integration-service]');
      if (!section) return;

      form.addEventListener('submit', function () {
        // Intentionally does NOT call preventDefault — the browser
        // continues on to Shopify's native contact form submission
        // exactly as if this script didn't exist. keepalive: true lets
        // the secondary fetch survive that navigation.
        sendToIntegration(section, form);
      });
    });
  }

  onReady(init);
})();